import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon';

const ICON_NAMES = {
  VIDEO: 'film',
  IMAGE: 'picture-o',
  WEB: 'code',
  FEED: 'feed',
  CALENDAR: 'calendar',
  URL: 'window-maximize',
  PDF: 'book',
  AQI: 'fan',
  AQI_VEDA: 'fan',
  FIDS: 'plane',
  URL: 'link',
  ZIP: 'code',
  AUDIO:'music'
};

const ContentTypeIcon = ({type, size}) => (
  <Icon name={ICON_NAMES[type] || 'question-circle'} size={size}/>
);

ContentTypeIcon.defaultProps = {
  size: '1.5rem',
};

ContentTypeIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number,
  ]).isRequired,
};

export default ContentTypeIcon;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ContentTypeIcon/index.js